import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../lib/helpers/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",

        green: "border-emerald-200 bg-emerald-50 text-emerald-700 hover:bg-emerald-100",
        lightGreen: "border-green-200 bg-green-50 text-green-700 hover:bg-green-100",
        orange: "border-amber-200 bg-amber-50 text-amber-700 hover:bg-amber-100",
        blue: "border-blue-200 bg-blue-50 text-blue-700 hover:bg-blue-100",
        lightBlue: "border-sky-200 bg-sky-50 text-sky-700 hover:bg-sky-100",
        purple: "border-violet-200 bg-violet-50 text-violet-700 hover:bg-violet-100",
        yellow: "border-yellow-200 bg-yellow-50 text-yellow-700 hover:bg-yellow-100",
        red: "border-rose-200 bg-rose-50 text-rose-700 hover:bg-rose-100",
        teal: "border-teal-200 bg-teal-50 text-teal-700 hover:bg-teal-100",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
  VariantProps<typeof badgeVariants> { }

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }